module.exports = __webpack_public_path__ + "static/media/3_col_12.ad9f1398.jpg";